import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Notification } from 'src/app/core/models/entities/notification.model';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-notifications-dialog',
  templateUrl: './notifications-dialog.component.html',
  styleUrls: ['./notifications-dialog.component.scss']
})
export class NotificationsDialogComponent implements OnInit {
  notifications: Notification[];

  constructor(private dialogRef: MatDialogRef<NotificationsDialogComponent>, private userService: UserService, private router: Router) { }

  ngOnInit(): void {
    this.userService.getNotifications().subscribe(response => {
      response.notifications.forEach(x => {
        if (!!x.icon) {
          x.icon = '/assets/images/notifications/' + x.icon + '.png';
        }
        else {
          x.icon = '/assets/images/notifications/default-icon.png';
        }
      });

      this.notifications = response.notifications;
    });
  }

  removeNotification(guid: string) {
    this.userService.removeNotification(guid).subscribe();
  }

  clearAll() {
    this.userService.clearNotifications().subscribe(() => {
      this.notifications = [];
      this.userService.refreshCurrentUser();
      setTimeout(() => {
        this.dialogRef.close();
      }, 500);
    });
  }
}